import React from 'react'
import { UserBadge } from '@vend/react-utilities'
import { ApiUser } from '@vend/types'

interface SearchableUserBadgeProps {
  user: ApiUser
  keyword?: string
}

export const SearchableUserBadge = (props: SearchableUserBadgeProps) => {
  return (
    <UserBadge
      size="small"
      keyword={props.keyword}
      user={{
        id: props.user.id,
        email: props.user.email || '',
        images: props.user.images,
        username: props.user.username,
        displayName: props.user.display_name,
      }}
    />
  )
}
